module.exports = __webpack_public_path__ + "img/alipay_icon.3adf0ab1.png";